/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { BASE_URL, Telegram_BASE_URL } from "../../utils/config";
import { useLocation, useNavigate } from 'react-router-dom';
import { InputText } from "primereact/inputtext";
import { Modal, Alert } from "react-bootstrap";

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import 'primeicons/primeicons.css';
import SessionLogout from '../../components/animation/sessionLogout';
import TelegramWidget from '../../components/widget/telegramWidget';
import DownloadIcon from "@mui/icons-material/Download";
import '../../../src/style/userlist_A.css'
import '../../../src/style/Mobuserlist.css'
import { PlusCircleIcon } from 'lucide-react';


const Userlist_Data = () => {

  const [UserData, setUserData] = useState([]);
  const location = useLocation();
const navigate = useNavigate();

const value = location.state?.value;
const heading = location.state?.heading;

useEffect(() => {
  if (!value) {
navigate("/admin/userlist_Data", {
  state: {
    value: "getUserDashboardData/TotalUsers",
    heading: "Total Users"
  }
});
  }
}, [value]);
  const [filters, setFilters] = useState("");
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [Errormessage, setErrormessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [subscriberData, setSubscriberData] = useState({
    first_name: '',
    mobile: '',
    email: '',
    purchase_date: '',
    starting_date: '',
    ending_date: '',
    plan_type: '',
    plan_amount: '',
    purchase_amount: '',
    coupon_code: '',
    country_code: '',
    product_identifier: '',
  });
  const [errorpopup, setErrorpopup] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false)
  const [BlockUserDialog, setBlockUserDialog] = useState(false);
  const [LoginConfirm, setLoginConfirm] = useState(false);
  const [LoginLimitDialog, setLoginLimitDialog] = useState(false);
  const [edituserDialog, setEdituserDialog] = useState(false);
  const [editSubsriberUserDialog, setEditSubsriberUserDialog] = useState(false);
  const [sendTelegramuserDialog, setSendTelegramuserDialog] = useState(false);
  const [deleteTelegramuserDialog, setDeleteTelegramuserDialog] = useState(false);
  const [userList, setUserList] = useState([]);
  const [deleteUserDialog, setDeleteUserDialog] = useState(false);
  const [loginuser, setLoginuser] = useState({});
  const [adduserDialog, setAdduserDialog] = useState(false)
  const [filteredUserLists, setfilteredUserLists] = useState({});
  const [userLists, setUserLists] = useState([]);



  const [LoginLimitValue, setLoginLimitValue] = useState("");

  const columns = [

    { field: 'first_name', header: 'First name' },
    { field: 'mobile', header: 'Phone' },
    { field: 'email', header: 'Email' },
    { field: 'state_name', header: 'State' },
    { field: 'city_name', header: 'City' },
    { field: 'gender', header: 'Gender' },
    { field: 'user_type', header: 'User Type' },
    { field: 'created_at', header: 'Joined' },
    { field: 'starting_date', header: 'Subscribed On' },
    { field: 'ending_date', header: 'Expiary Date' },
    { field: 'login_devices', header: 'login Limit' },
    { field: 'action', header: 'Action' },
  ];
  const subscribercolumns = [

    { field: 'first_name', header: 'First name' },
    { field: 'mobile', header: 'Phone' },
    { field: 'email', header: 'Email' },
    { field: 'created_at', header: 'Joined' },
    { field: 'starting_date', header: 'Subscribed On' },
    { field: 'ending_date', header: 'Expiary Date' },
    { field: 'remarks', header: 'Remarks' },
    { field: 'action', header: 'Action' }
  ];




  useEffect(() => {
    fetchUserData();

    let Loginuser = JSON.parse(localStorage.getItem("userdetails"));
    setLoginuser(Loginuser);
  }, []);


  const fetchUserData = async () => {
    setLoading(true);
    const token = localStorage.getItem("AUTH_TOKEN");
    const response = await fetch(`${BASE_URL}/${value}`, {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-type": "application/Json"
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("User data", res.usersData);
        if (res.status === 403) {
          setLoading(false);
          setSessionExpired(true)
          setTimeout(() => {
            setSessionExpired(false)
            navigate('/login')
          }, 5000)
        }
        else if (res.status === 401) {
          setLoading(false);
          setSessionExpired(true)
          setTimeout(() => {
            setSessionExpired(false)
            navigate('/login')
          }, 5000)
        } else {
          setLoading(false);
          setUserData(res.usersData);
          setUserList(res.usersData);
          setUserLists(res.usersData);
        }
      })
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSubscriberData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    console.log("value of change",value)
    setUserList((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const HandleBlockUser = async () => {
    console.log(userList);
    const token = localStorage.getItem("AUTH_TOKEN");
    const isBlocked = `${userList.is_blocked === false ? 1 : 0}`;
    await fetch(`${BASE_URL}/blockeduser/${userList.user_id}/${isBlocked}`, {
      method: "PUT",
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }).then((res) => res.json())
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          if (userList.is_blocked === false) {
            setErrormessage("User Blocked Successfully");
          } else {
            setErrormessage("User UnBlocked Successfully");
          }

          setShowSuccessMessage(true);
          fetchUserData(); // Show success message here
          setTimeout(() => {
            setShowSuccessMessage(false);
          }, 2000);
        }
        else if (res.status === 403) {
          setSessionExpired(true)
          setTimeout(() => {
            setSessionExpired(false)
            navigate('/login')
          }, 5000)
        }
        else if (res.status === 401) {
          setSessionExpired(true)
          setTimeout(() => {
            setSessionExpired(false)
            navigate('/login')
          }, 5000)
        }
        else {
          setErrormessage("Failed to Block Successfully");
          setShowErrorMessage(true); // Show an error message here, if applicable
          setTimeout(() => {
            setShowErrorMessage(false);

          }, 2000);
        }

      })

    setBlockUserDialog(false);

  }


  const confirmSendTelegramuser = async (userlist) => {
    console.log(userlist);

    setUserList(userlist);
    setSendTelegramuserDialog(true);
  };

  const confirmDeleteTelegramuser = async (userlist) => {
    console.log(userlist);

    setUserList(userlist);
    setDeleteTelegramuserDialog(true);
  };

  const sendTelegramJoiningLink = async () => {
    try {
      const UserData = {
        phone: userList.mobile, // Replace with actual user phone
      };

      const response = await fetch(`${Telegram_BASE_URL}/add_user`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json', // Ensure the API expects JSON
        },
        body: JSON.stringify(UserData),
      })
        .then((res) => res.json())
        .then((res) => {
          console.log("res", res);
          if (res.status == 200) {

            setUserList("");
            setSendTelegramuserDialog(false)
            setErrormessage("Link Successfully Send To User.");
            setShowSuccessMessage(true);

            setTimeout(() => {
              setShowSuccessMessage(false);
              setErrormessage("");
            }, 2000);

          } else {
            setSendTelegramuserDialog(false)
            setErrormessage("Failed to send telegram link to user User Data");
            setShowErrorMessage(true); // Show an error message here, if applicable
            setTimeout(() => {
              setShowErrorMessage(false);
              // Additional logic for handling the "else" condition
            }, 3000);

          }
        }).catch((error) => {
          setSendTelegramuserDialog(false)
          setErrormessage("Failed to send telegram link to user User Data");
          setShowErrorMessage(true); // Show an error message here, if applicable
          setTimeout(() => {
            setShowErrorMessage(false);
            // Additional logic for handling the "else" condition
          }, 1700);

        })

    } catch (error) {
      setSendTelegramuserDialog(false)
      setErrormessage("Failed to send telegram link to user User Data");
      setShowErrorMessage(true); // Show an error message here, if applicable
      setTimeout(() => {
        setShowErrorMessage(false);
        // Additional logic for handling the "else" condition
      }, 1700);

    }
  }

  const RemoveUserFromTelegram = async () => {
    try {
      const userData = {
        phone: userList.mobile, // Replace with actual user phone
      };

      const response = await fetch(`${Telegram_BASE_URL}/remove_user`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json', // Ensure the API expects JSON
        },
        body: JSON.stringify(userData),
      })
        .then((res) => res.json())
        .then((res) => {
          console.log("res", res);
          if (res.status == 200) {

            setUserList("");
            setDeleteTelegramuserDialog(false);

            setErrormessage("User Successfully Remove From Telegram Channel.");
            setShowSuccessMessage(true);

            setTimeout(() => {
              setShowSuccessMessage(false);
              setErrormessage("")
            }, 2000);

          } else {
            setDeleteTelegramuserDialog(false);
            setErrormessage("Failed to send telegram link to user User Data");
            setShowErrorMessage(true); // Show an error message here, if applicable
            setTimeout(() => {
              setShowErrorMessage(false);
              // Additional logic for handling the "else" condition
            }, 3000);

          }
        }).catch((error) => {
          setDeleteTelegramuserDialog(false);
          setErrormessage("Failed to send telegram link to user User Data");
          setShowErrorMessage(true); // Show an error message here, if applicable
          setTimeout(() => {
            setShowErrorMessage(false);
            // Additional logic for handling the "else" condition
          }, 1700);


        })
    } catch (error) {
      setDeleteTelegramuserDialog(false);
      setErrormessage("Failed to send telegram link to user User Data");
      setShowErrorMessage(true); // Show an error message here, if applicable
      setTimeout(() => {
        setShowErrorMessage(false);
        // Additional logic for handling the "else" condition
      }, 1700);
    }
  }


  const actionBodyTemplate = (rowData) => {
    const isSuperAdmin = rowData.usertype_id === 1;

    return (
      <div className="actions">
        <i
          className="pi pi-user-edit"
          style={{ color: "#8a8a5c", cursor: "pointer", marginRight: "10px" }}
          title="Edit"
          onClick={() => confirmEdituser(rowData)}
        ></i>


        <i
          className="pi pi-ban"
          style={{
            color: rowData.is_blocked === false ? "green" : "red",
            cursor: isSuperAdmin ? "not-allowed" : "pointer",
            marginRight: "10px",
          }}
          title={isSuperAdmin ? "Action not allowed" : rowData.is_blocked === false ? "Block" : "Unblock"}
          onClick={() => !isSuperAdmin && confirmBlockUser(rowData)}
        ></i>



        <i
          className="pi pi-trash"
          style={{ color: "#ff4d4d", cursor: isSuperAdmin ? "not-allowed" : "pointer", }}
          title={isSuperAdmin ? "Action not allowed" : "Delete"}
          onClick={() => !isSuperAdmin && confirmDeleteUser(rowData)}
        ></i>
{/*        <i
          className="pi pi-send"
          style={{ color: "blue", cursor: "pointer", marginLeft: "10px" }}
          title={isSuperAdmin ? "Action not allowed" : "Send Telegram Joining Link"}
          onClick={() => confirmSendTelegramuser(rowData)}
        ></i>
        <i
          className="pi pi-times"
          style={{ color: "#8a8a5c", cursor: "pointer", marginLeft: "10px" }}
          title={isSuperAdmin ? "Action not allowed" : "Remove User From Telegram"}
          onClick={() => confirmDeleteTelegramuser(rowData)}
        ></i>
*/}


      </div>
    );
  };

  const subscriberActionBodyTemplate = (rowData) => {
    const isSuperAdmin = rowData.usertype_id === 1;

    return (
      <div className="actions">
        <i
          className="pi pi-user-edit"
          style={{ color: "#8a8a5c", cursor: "pointer", marginRight: "10px" }}
          title="Edit"
          onClick={(e) => {e.stopPropagation(); 
             confirmEditSubscriberUser(rowData)}}
        ></i>


{/*        <i
          className="pi pi-send"
          style={{ color: "blue", cursor: "pointer", marginLeft: "10px" }}
          title={isSuperAdmin ? "Action not allowed" : "Send Telegram Joining Link"}
          onClick={() => confirmSendTelegramuser(rowData)}
        ></i>
        <i
          className="pi pi-times"
          style={{ color: "#8a8a5c", cursor: "pointer", marginLeft: "10px" }}
          title={isSuperAdmin ? "Action not allowed" : "Remove User From Telegram"}
          onClick={() => confirmDeleteTelegramuser(rowData)}
        ></i>
*/}


      </div>
    );
  };

  const showuserType = (data) => {
    // console.log("data",data)
    return (
      <div style={{ color: data === 'Paid' ? 'green' : 'black' }}>{data}</div>
    )
  }


  const LoginLimitSection = (rowData) => {
    return (
      <div>

        {rowData === 0 ? (
          <i
            className="pi pi-pencil"
            style={{ color: "#8a8a5c", cursor: "pointer", marginRight: "10px" }}
          ></i>
        ) : (
          <div style={{ display: "flex", margin: "auto" }}>
            <span style={{ margin: "auto" }}>{rowData}</span>
            <i
              className="pi pi-plus-circle"
              style={{ color: "#8a8a5c", cursor: "pointer", margin: "auto" }}
              onClick={handleLoginLimitUpdate}
            ></i>
          </div>
        )}
      </div>
    );
  };

  const openAddUserDialog = () => {
    setAdduserDialog(true)
  }

  const handleClose = () => {
    setAdduserDialog(false)
  };
  const handleEditClose = () => {
    setEditSubsriberUserDialog(false)
  };


  const AddUserSubscription = async (e) => {
    try {
      e.preventDefault()
      // Validation

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const mobileRegex = /^\d{10}$/;
      const countryCodeRegex = /^\d{1,3}$/;
      if (
        !subscriberData.first_name ||
        !subscriberData.email ||
        !subscriberData.mobile ||
        !subscriberData.country_code ||
        !subscriberData.purchase_date ||
        !subscriberData.starting_date ||
        !subscriberData.ending_date ||
        !subscriberData.product_identifier
      ) {

        setErrorpopup(true)
        setTimeout(() => {
          setShowErrorMessage(false);
        }, 1500) // Add proper error handling
        return;
      }


      if (!emailRegex.test(subscriberData.email)) {
        setErrormessage("Invalid email format.");
        setValidationError(true);
        setTimeout(() => {
          setValidationError(false);
          setErrormessage("");
        }, 1500);
        return;
      }

      if (!mobileRegex.test(subscriberData.mobile)) {
        setErrormessage("Mobile number must be 10 digits.");
        setValidationError(true);
        setTimeout(() => {
          setValidationError(false);
          setErrormessage("");
        }, 1500);
        return;
      }

      if (!countryCodeRegex.test(subscriberData.country_code)) {
        setErrormessage("Country code must be 3 digits.");
        setValidationError(true);
        setTimeout(() => {
          setValidationError(false);
          setErrormessage("");
        }, 1500);
        return;
      }

      // Convert dates to Date objects for comparison
      const purchaseDate = new Date(subscriberData.purchase_date);
      const startingDate = new Date(subscriberData.starting_date);
      const endingDate = new Date(subscriberData.ending_date);

      if (startingDate < purchaseDate) {
        setErrormessage("Starting date cannot be earlier than purchase date.");
        setValidationError(true);
        setTimeout(() => {
          setValidationError(false);
          setErrormessage("");
        }, 1500);
        return;
      }

      if (endingDate < startingDate) {
        setErrormessage("Ending date cannot be earlier than starting date.");
        setValidationError(true);
        setTimeout(() => {
          setValidationError(false);
          setErrormessage("");
        }, 1500);
        return;
      }

      // Prepare the payload
      const addsubscriberData = {
        first_name: subscriberData.first_name,
        email: subscriberData.email,
        mobile: subscriberData.mobile,
        country_code: subscriberData.country_code,
        purchase_date: subscriberData.purchase_date,
        starting_date: subscriberData.starting_date,
        ending_date: subscriberData.ending_date,
        product_identifier: subscriberData.product_identifier,
        purchase_amount: subscriberData.purchase_amount,
        plan_amount: subscriberData.plan_amount,
        plan_type: subscriberData.plan_type,
        coupon_code: subscriberData.coupon_code
      };

      const details = JSON.parse(localStorage.getItem('userData'));
      const created_by = details.user_id
      const token = localStorage.getItem("AUTH_TOKEN");
      // API call
      const response = await fetch(`${BASE_URL}/Addsubscriber`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ addsubscriberData, created_by }),
      });

      console.log('reposne', response)
      // Handle API response
      if (response.ok) {
        const data = await response.json();
        console.log("Form submitted successfully:", data);
        const subscriberData = data.subscriberData
        // alert("Subscription added successfully!");
        // setUserData((prevUserData) => [...prevUserData, subscriberData]);
        setSubscriberData({
          first_name: '',
          mobile: '',
          email: '',
          purchase_date: '',
          starting_date: '',
          ending_date: '',
          plan_type: '',
          plan_amount: '',
          purchase_amount: '',
          coupon_code: '',
          country_code: '',
          product_identifier: '',
        })
        setAdduserDialog(false)
        setShowSuccessMessage(true)
        setErrormessage("Joining Link Successfully Send TO User.")
        setTimeout(() => {
          setShowSuccessMessage(false)
          setErrormessage("")
          window.location.reload()
        }, 1500)
        // Reset the form or handle success
      } else {
        const errorData = await response.json();
        console.error("API Error:", errorData);
        // alert("Failed to add subscription. Please try again.");
        setErrormessage("Failed to Send Joining Link. Please try again.")
        setShowErrorMessage(true)

        setTimeout(() => {
          setShowErrorMessage(false)
          setErrormessage("")
        }, 1500)
      }
    } catch (error) {
      console.error("Error in AddUserSubscription:", error);
      // alert("An unexpected error occurred while submitting the form.");
      setShowErrorMessage(true)
      setErrormessage("Failed to Send Joining Link. Please try again.")
      setTimeout(() => {
        setShowErrorMessage(false)
        setErrormessage("")
      }, 1500)
    }
  };


  const EditUserSubscription = async (e) => {
    try {
      e.preventDefault()
      // Validation
      const recordId  = userList.id
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const mobileRegex = /^\d{10}$/;
      const countryCodeRegex = /^\d{1,3}$/;
      if (
        !userList.first_name ||
        !userList.email ||
        !userList.mobile ||
        !userList.country_code ||
        !userList.purchase_date ||
        !userList.starting_date ||
        !userList.ending_date ||
        !userList.product_identifier
      ) {

        setErrorpopup(true)
        setTimeout(() => {
          setShowErrorMessage(false);
        }, 1500) // Add proper error handling
        return;
      }


      if (!emailRegex.test(userList.email)) {
        setErrormessage("Invalid email format.");
        setValidationError(true);
        setTimeout(() => {
          setValidationError(false);
          setErrormessage("");
        }, 1500);
        return;
      }

      if (!mobileRegex.test(userList.mobile)) {
        setErrormessage("Mobile number must be 10 digits.");
        setValidationError(true);
        setTimeout(() => {
          setValidationError(false);
          setErrormessage("");
        }, 1500);
        return;
      }

      if (!countryCodeRegex.test(userList.country_code)) {
        setErrormessage("Country code must be 3 digits.");
        setValidationError(true);
        setTimeout(() => {
          setValidationError(false);
          setErrormessage("");
        }, 1500);
        return;
      }

      // Convert dates to Date objects for comparison
      const purchaseDate = new Date(userList.purchase_date);
      const startingDate = new Date(userList.starting_date);
      const endingDate = new Date(userList.ending_date);

      if (startingDate < purchaseDate) {
        setErrormessage("Starting date cannot be earlier than purchase date.");
        setValidationError(true);
        setTimeout(() => {
          setValidationError(false);
          setErrormessage("");
        }, 1500);
        return;
      }

      if (endingDate < startingDate) {
        setErrormessage("Ending date cannot be earlier than starting date.");
        setValidationError(true);
        setTimeout(() => {
          setValidationError(false);
          setErrormessage("");
        }, 1500);
        return;
      }

      // Prepare the payload
          // Helper function to get only changed fields
    const getChangedFields = (original, updated) => {
      const changedFields = {};
      for (const key in updated) {
        if (updated[key] !== original[key]) {
          changedFields[key] = updated[key];
        }
      }
      return changedFields;
    };

    // Get changed fields
    const changedData = getChangedFields(subscriberData,userList);

    if (Object.keys(changedData).length === 0) {
      setErrormessage("No changes detected.");
      setValidationError(true);
      setTimeout(() => {
        setValidationError(false);
        setErrormessage("");
      }, 1500);
      return;
    }

      const details = JSON.parse(localStorage.getItem('userData'));
      const updated_by = details.user_id
      const token = localStorage.getItem("AUTH_TOKEN");
      // API call
      const response = await fetch(`${BASE_URL}/Editsubscriber/${recordId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ changedData, updated_by }),
      });

      console.log('reposne', response)
      // Handle API response
      if (response.ok) {
        const data = await response.json();
        console.log("Form submitted successfully:", data);
        let updateData = data.updatedData
        // alert("Subscription added successfully!");
        setUserData((prevUserData) =>
          prevUserData.map((item) =>
            item.id === updateData.id ? updateData : item
          )
        );

        setSubscriberData({
          first_name: '',
          mobile: '',
          email: '',
          purchase_date: '',
          starting_date: '',
          ending_date: '',
          plan_type: '',
          plan_amount: '',
          purchase_amount: '',
          coupon_code: '',
          country_code: '',
          product_identifier: '',
        })
        setUserList({})
        setEditSubsriberUserDialog(false)
        setShowSuccessMessage(true)
        setErrormessage("Successfully Updated Subscriber Date.")
        setTimeout(() => {
          setShowSuccessMessage(false)
          setErrormessage("")
        }, 1500)
        // Reset the form or handle success
      } else {
        const errorData = await response.json();
        console.error("API Error:", errorData);
        // alert("Failed to add subscription. Please try again.");

        setErrormessage("Failed to Update Subscriber Data. Please try again.")
        setShowErrorMessage(true)
        setEditSubsriberUserDialog(false)
        setSubscriberData({
          first_name: '',
          mobile: '',
          email: '',
          purchase_date: '',
          starting_date: '',
          ending_date: '',
          plan_type: '',
          plan_amount: '',
          purchase_amount: '',
          coupon_code: '',
          country_code: '',
          product_identifier: '',
        })
        setUserList({})
        
        setTimeout(() => {
          setShowErrorMessage(false)
          setErrormessage("")
        }, 1500)
      }
    } catch (error) {
      console.error("Error in Edit UserSubscription:", error);
      // alert("An unexpected error occurred while submitting the form.");
      setEditSubsriberUserDialog(false)
      setShowErrorMessage(true)
      setErrormessage("Failed to Update Subscriber Data. Please try again.")
      setAdduserDialog({
        first_name: '',
        mobile: '',
        email: '',
        purchase_date: '',
        starting_date: '',
        ending_date: '',
        plan_type: '',
        plan_amount: '',
        purchase_amount: '',
        coupon_code: '',
        country_code: '',
        product_identifier: '',
      })
      setUserList({})
      
      setTimeout(() => {
        setShowErrorMessage(false)
        setErrormessage("")
      }, 1500)
    }
  };

  const ImportExcel = () => {
    navigate('/importUserExcel')
  }

//   const leftToolbarTemplate = () => {
//     return (
//       <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
//         <span className="p-input-icon-left table-search">
//           <i className="pi pi-search" />
//           <InputText
//             type="search"
//             value={filters}
//             onChange={(e) => { handleSearch(e) }}
//             placeholder="Search..."
//           />
//         </span>
//         <div>

//           <Button
//             variant="contained"
//             endIcon={<DownloadIcon />}
//             onClick={openAddUserDialog}
//             style={{ marginRight: '10px' }}
//           >
//             Add User
//           </Button>

//           <Button
//             variant="contained"
//             endIcon={<DownloadIcon />}
//             onClick={ImportExcel}
//             style={{ marginRight: '10px' }}
//           >
//             Import Excel
//           </Button>
//           <Button
//             variant="contained"
//             endIcon={<DownloadIcon />}
//             onClick={exportCSV}

//           >
//             Export
//           </Button>
//         </div>
//       </div>
//     );
//   };

  // const rightToolbarTemplate = () => {
  //   return (
  //     <div >
  //       <Stack direction="row" spacing={2}>
  //         {/* <Link to="/usercreateForm">
  //           <Button variant="contained" startIcon={<AddIcon />}>
  //             Add User
  //           </Button>
  //         </Link> */}

  //       </Stack>
  //     </div>
  //   );
  // };

  const exportCSV = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(userLists);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "User_List");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        const date = new Date();

        // Extract date components
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");

        // Extract time components
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const seconds = date.getSeconds().toString().padStart(2, "0");

        // Combine date and time components
        const dateTime = `${year}-${month}-${day}_${hours}:${minutes}:${seconds}`;

        module.default.saveAs(
          data,
          fileName + "_export_" + dateTime + EXCEL_EXTENSION
        );
      }
    });
  };


  const handleSearch = (event) => {
    let filterText = event.target.value; // fixed typo
    setFilters(filterText);

    // Assuming `setUserData` updates the filtered list
    setUserData(
      userLists.filter((row) =>
        Object.values(row).some(
          (value) =>
            typeof value === 'string' &&
            value.toLowerCase().includes(filterText.toLowerCase())
        )
      )
    );
  };



  const handleLoginLimitUpdate = () => {
    console.log(setUserList);
    setLoginLimitDialog(true);

  }

  const handleUpdateLoginLimit = async () => {
    console.log("userList increase login limit", userList)
    let loginuser = JSON.parse(localStorage.getItem("userData"));
    let body = JSON.stringify({
      userdetails: {
        login_devices: LoginLimitValue
      },
      modified_by: loginuser.user_id,
    });

    const token = localStorage.getItem("AUTH_TOKEN");
    const response = await fetch(`${BASE_URL}/updateuser/${userList.user_id}`, {
      method: "PUT",
      body,
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },

    }).then((res) => res.json())
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          setLoginLimitDialog(false);
          setErrormessage("User Login Limit Updated Successfully");
          setShowSuccessMessage(true); // Show success message here
          setTimeout(() => {
            setShowSuccessMessage(false);

            // navigate("/userlist");
            window.location.reload();

          }, 3000);
        }

        else if (res.status === 403) {
          setSessionExpired(true)
          setTimeout(() => {
            setSessionExpired(false)
            navigate('/login')
          }, 5000)
        }
        else if (res.status === 401) {
          setSessionExpired(true)
          setTimeout(() => {
            setSessionExpired(false)
            navigate('/login')
          }, 5000)
        }
        else {
          setErrormessage("Failed to Update User Login Limit");
          setShowErrorMessage(true); // Show an error message here, if applicable
          setTimeout(() => {
            setShowErrorMessage(false);
            // Additional logic for handling the "else" condition
          }, 3000);

        }

      })





  }

  const confirmEdituser = async (userlist) => {
    console.log(userlist);

    // setUserList(userlist);
    setEdituserDialog(true);
  };

  const formateditDate = (dateString) => {
    console.log("type od date",typeof(dateString),dateString)
    if (!dateString) return ''; // Handle empty or undefined dates
    const date = new Date(dateString); // Parse the ISO 8601 string
    if (isNaN(date.getTime())) return ''; // Handle invalid dates
  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2 digits for month
    const day = String(date.getDate()).padStart(2, '0');
    console.log(`${year}-${month}-${day}`)
    return `${year}-${month}-${day}`;  // 2025-01-29
  };

  

  const confirmEditSubscriberUser = async (userlist) => {
    console.log(userlist);

    const formattedUserlist = {
      ...userlist,
      purchase_date: formateditDate(userlist.purchase_date),
      starting_date: formateditDate(userlist.starting_date),
      ending_date: formateditDate(userlist.ending_date),
    };
    console.log("after date modified",formattedUserlist)
    setSubscriberData(formattedUserlist);
    setUserList(formattedUserlist);
    setEditSubsriberUserDialog(true);
  };

  const hideEditUserDialog = () => {
    setEdituserDialog(false);
  };

  const hideSendTelegramUserDialog = () => {
    // setUserList(null);
    setSendTelegramuserDialog(false);
  };
  const hideDeleteTelegramUserDialog = () => {
    // setUserList(null);
    setDeleteTelegramuserDialog(false);
  };

  const confirmDeleteUser = (userlist) => {
    console.log(userlist);
    setUserList(userlist);
    setDeleteUserDialog(true);
  };

  const confirmBlockUser = (userlist) => {
    console.log("userlist", userlist)
    setUserList(userlist);
    setBlockUserDialog(true);
  };

  const hideBlockUSer = () => {
    setBlockUserDialog(false);

  };



  const edituser = async () => {
    let userdetails = userList;
    console.log("userdetails===============: ", userdetails)
    navigate("/editprofile", {
      state: { userdetials: userdetails, edittype: "user" },
    });
  };

  const hideDeleteDialog = () => {
    setDeleteUserDialog(false);
  };

  const deleteUser = async () => {
    const token = localStorage.getItem("AUTH_TOKEN");
    const response = await fetch(`${BASE_URL}/deleteuser/${userList.user_id}`, {
      method: "DELETE",
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("res", res);
        if (res.status == 200) {
          let _products = UserData.filter(
            (val) => val.user_id !== userList.user_id
          );
          setUserData(_products);
          setfilteredUserLists(_products);
          setDeleteUserDialog(false);
          setUserList("");


          setErrormessage("User Data Deleted Successfully");
          setShowSuccessMessage(true); // Show success message here
          setTimeout(() => {
            setShowSuccessMessage(false);
            window.location.reload();
          }, 3000);
        } else if (res.status === 403) {
          setSessionExpired(true)
          setTimeout(() => {
            setSessionExpired(false)
            navigate('/login')
          }, 5000)
        }
        else if (res.status === 401) {
          setSessionExpired(true)
          setTimeout(() => {
            setSessionExpired(false)
            navigate('/login')
          }, 5000)
        } else {
          setErrormessage("Failed to delete User Data");
          setShowErrorMessage(true); // Show an error message here, if applicable
          setTimeout(() => {
            setShowErrorMessage(false);
            // Additional logic for handling the "else" condition
          }, 3000);

        }
      }).catch((error) => {

        setErrormessage("Failed to delete User Data");
        setShowErrorMessage(true); // Show an error message here, if applicable
        setTimeout(() => {
          setShowErrorMessage(false);
          // Additional logic for handling the "else" condition
        }, 1700);
      })
    setDeleteUserDialog(false);

  };



  const onRowSelect = (e) => {
    console.log(e.data);
    setUserList(e.data);
    setLoginLimitValue(e.data.login_devices)
  };


  const formatDate = (data) => {
    if (data) {
      return new Date(data).toLocaleDateString('en-GB')
    } else {
      return ''
    }

  }
  
  if (loading) {
  return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
      </div>
  );
}

  return (
    <div>

      {/* User data  table  */}
<div className="user-list">

    {/* ROW 1: BACK + TITLE */}
    <div className="rkb-header-row">
      <button
        className="rkb-back-btn"
        onClick={() => navigate(-1)}
      >
        ← Back
      </button>

      <h2 className="rkb-page-title">{heading}</h2>

      {/* spacer for center alignment */}
      <div style={{ width: "30px" }} />
    </div>

    {/* ROW 2: SEARCH + BUTTONS */}
    <div className="rkb-toolbar-row">
    <span className="p-input-icon-left table-search">
        <i className="pi pi-search ml-1" />
        <InputText
        type="search"
        value={filters}
        onChange={handleSearch}
        placeholder="Search..."
        />
    </span>

      <div className="rkb-toolbar-actions">
        <Button
            variant="contained"
            endIcon={<PlusCircleIcon />}
            onClick={openAddUserDialog}
            style={{ marginRight: '10px' }}
          >
            ADD USER 
          </Button>

        <Button
            variant="contained"
            endIcon={<DownloadIcon />}
            onClick={ImportExcel}
            style={{ marginRight: '10px' }}
          >          IMPORT EXCEL
        </Button>

        <Button
            variant="contained"
            endIcon={<DownloadIcon />}
            onClick={exportCSV}

          >          EXPORT
        </Button>
      </div>
    </div>

  

  {/* TABLE STARTS */}

        <div className="UserDataTable">


          {/* {rightToolbarTemplate()} */}


              <div>{heading === 'Total Active Subscriber' ?
                <DataTable
                  value={UserData}
                  paginator rows={10}
                  rowsPerPageOptions={[10, 20, 30, 50]}
                  onRowClick={onRowSelect}
                  tableStyle={{ minWidth: '60rem' }}>
                    {subscribercolumns.map((col, i) => (
                    <Column
                        key={i}
                        field={col.field}
                        header={col.header}
                        body={(rowData) =>
                        col.field === "created_at"
                            ? formatDate(rowData[col.field])
                            : col.field === "starting_date"
                            ? formatDate(rowData[col.field])
                            : col.field === "ending_date"
                            ? formatDate(rowData[col.field])
                            : col.field === "action"
                            ? subscriberActionBodyTemplate(rowData)
                            : rowData[col.field]
                        }
                        style={
                        col.field === "action"
                            ? { width: "120px", textAlign: "center" }
                            : {}
                        }
                    />
                    ))}
                  

                </DataTable>
                : <DataTable
                  value={UserData}
                  paginator rows={10}
                  rowsPerPageOptions={[10, 20, 30, 50]}
                  onRowClick={onRowSelect}
                  tableStyle={{ minWidth: '50rem' }}>
                    {columns.map((col, i) => (
                    <Column
                        key={i}
                        field={col.field}
                        header={col.header}
                        body={(rowData) =>
                        col.field === "created_at"
                            ? formatDate(rowData[col.field])
                            : col.field === "starting_date"
                            ? formatDate(rowData[col.field])
                            : col.field === "ending_date"
                            ? formatDate(rowData[col.field])
                            : col.field === "action"
                            ? actionBodyTemplate(rowData)
                            : col.field === "login_devices"
                            ? LoginLimitSection(rowData[col.field])
                            : col.field === "user_type"
                            ? showuserType(rowData[col.field])
                            : rowData[col.field]
                        }
                        style={
                        col.field === "action"
                            ? { width: "140px", textAlign: "center" }
                            : col.field === "mobile"
                            ? { width: "160px" }
                            : {}
                        }
                    />
                    ))}
                  
                </DataTable>}</div>
          
        </div>
      </div> 

      {/*  add user in subscription dialog  adduserDialog */}

      <Dialog open={adduserDialog} className='popup-createreport'>
        <>
          <div className='CreateReport-Close'>
            <i className="pi pi-times" onClick={handleClose} style={{ color: "#697565" }}></i>
          </div>
          <div className='CreateReport_Page'>
            <h1>Add User Subscription</h1>
            <form onSubmit={AddUserSubscription}>
              <div className="Report-inputgroup">
                <label>Full Name:<span style={{ color: 'red' }}>*</span></label>
                <input type="text" required className='inputfield' placeholder='First Name' name='first_name' value={subscriberData.first_name} onChange={handleChange} />
              </div>

              <div className="Report-inputgroup">
                <label>Country Code:<span style={{ color: 'red' }}>*</span></label>
                <input type="text" required className='inputfield' placeholder='country code' name='country_code' value={subscriberData.country_code} onChange={handleChange} />
              </div>
              <div className="Report-inputgroup">
                <label>Phone:<span style={{ color: 'red' }}>*</span></label>
                <input type="tel" required className='inputfield' placeholder='Phone' name='mobile' value={subscriberData.mobile} onChange={handleChange} />
              </div>

              <div className="Report-inputgroup">
                <label>Email:<span style={{ color: 'red' }}>*</span></label>
                <input type="email" required className='inputfield' placeholder='email' name='email' value={subscriberData.email} onChange={handleChange} />

              </div>

              <div className="Report-inputgroup">
                <label>Purchase Date:<span style={{ color: 'red' }}>*</span></label>
                <input type="date" required className='inputfield' placeholder='purchase date' name='purchase_date' value={subscriberData.purchase_date} onChange={handleChange} />

              </div>
              <div className="Report-inputgroup">
                <label>Starting Date:<span style={{ color: 'red' }}>*</span></label>
                <input type="date" required className='inputfield' name='starting_date' placeholder='starting date' value={subscriberData.starting_date} onChange={handleChange} />
              </div>
              <div className="Report-inputgroup">
                <label>Ending Date:<span style={{ color: 'red' }}>*</span></label>
                <input type="date" required className='inputfield' name='ending_date' placeholder='ending date' value={subscriberData.ending_date} onChange={handleChange} />
              </div>
              <div className="Report-inputgroup">
                <label>Plan Type:</label>
                <input type="text" className='inputfield' name='plan_type' placeholder='plan type' value={subscriberData.plan_type} onChange={handleChange} />
              </div>
              <div className="Report-inputgroup">
                <label>Plan Amount:</label>
                <input type="number" className='inputfield' name='plan_amount' placeholder='plan amount' value={subscriberData.plan_amount} onChange={handleChange} />
              </div>
              <div className="Report-inputgroup">
                <label>Purchase Amount: </label>
                <input type="number" className='inputfield' name='purchase_amount' placeholder='purchase amount' value={subscriberData.purchase_amount} onChange={handleChange} />
              </div>
              <div className="Report-inputgroup">
                <label>Coupon Code: </label>
                <input type="text" className='inputfield' name='coupon_code' placeholder='coupon code' value={subscriberData.coupon_code} onChange={handleChange} />
              </div>
              <div className="Report-inputgroup">
                <label>Product Identifier:<span style={{ color: 'red' }}>*</span></label>
                <input type="text" required className='inputfield' name='product_identifier' placeholder='Product identifier' value={subscriberData.product_identifier} onChange={handleChange} />
              </div>




              <button type="submit" className="Button-Submit" style={{ 'margin-left': 'auto', 'margin-right': 'auto' }}   >Submit</button>
            </form>

          </div>
        </>

      </Dialog>

      {/* edit subsriber user */}
      <Dialog open={editSubsriberUserDialog} className='popup-createreport'>
        <>
          <div className='CreateReport-Close'>
            <i className="pi pi-times" onClick={handleEditClose} style={{ color: "#697565" }}></i>
          </div>
          <div className='CreateReport_Page'>
            <h1>Edit User Subscription</h1>
            <form onSubmit={EditUserSubscription}>
              <div className="Report-inputgroup">
                <label>Full Name:<span style={{ color: 'red' }}>*</span></label>
                <input type="text" required className='inputfield' placeholder='First Name' name='first_name' value={userList.first_name} onChange={handleEditChange} />
              </div>

              <div className="Report-inputgroup">
                <label>Country Code:<span style={{ color: 'red' }}>*</span></label>
                <input type="text" required className='inputfield' placeholder='country code' name='country_code' value={userList.country_code} onChange={handleEditChange} />
              </div>
              <div className="Report-inputgroup">
                <label>Phone:<span style={{ color: 'red' }}>*</span></label>
                <input type="tel" required className='inputfield' placeholder='Phone' name='mobile' value={userList.mobile} onChange={handleEditChange} />
              </div>

              <div className="Report-inputgroup">
                <label>Email:<span style={{ color: 'red' }}>*</span></label>
                <input type="email" required className='inputfield' placeholder='email' name='email' value={userList.email} onChange={handleEditChange} />

              </div>

              <div className="Report-inputgroup">
                {console.log("date of purchase",userList.purchase_date)}
                <label>Purchase Date:<span style={{ color: 'red' }}>*</span></label>
                <input type="date" required className='inputfield' placeholder='purchase date' name='purchase_date' value={userList.purchase_date} onChange={handleEditChange} />

              </div>
              <div className="Report-inputgroup">
                <label>Starting Date:<span style={{ color: 'red' }}>*</span></label>
                <input type="date" required className='inputfield' name='starting_date' placeholder='starting date' value={userList.starting_date} onChange={handleEditChange} />
              </div>
              <div className="Report-inputgroup">
                <label>Ending Date:<span style={{ color: 'red' }}>*</span></label>
                <input type="date" required className='inputfield' name='ending_date' placeholder='ending date' value={userList.ending_date} onChange={handleEditChange} />
              </div>
              <div className="Report-inputgroup">
                <label>Plan Type:</label>
                <input type="text" className='inputfield' name='plan_type' placeholder='plan type' value={userList.plan_type} onChange={handleEditChange} />
              </div>
              <div className="Report-inputgroup">
                <label>Plan Amount:</label>
                <input type="number" className='inputfield' name='plan_amount' placeholder='plan amount' value={userList.plan_amount} onChange={handleEditChange} />
              </div>
              <div className="Report-inputgroup">
                <label>Purchase Amount: </label>
                <input type="number" className='inputfield' name='purchase_amount' placeholder='purchase amount' value={userList.purchase_amount} onChange={handleEditChange} />
              </div>
              <div className="Report-inputgroup">
                <label>Coupon Code: </label>
                <input type="text" className='inputfield' name='coupon_code' placeholder='coupon code' value={userList.coupon_code} onChange={handleEditChange} />
              </div>
              <div className="Report-inputgroup">
                <label>Product Identifier:<span style={{ color: 'red' }}>*</span></label>
                <input type="text" required className='inputfield' name='product_identifier' placeholder='Product identifier' value={userList.product_identifier} onChange={handleEditChange} />
              </div>


              <button type="submit" className="Button-Submit" style={{ 'margin-left': 'auto', 'margin-right': 'auto' }}   >Submit</button>
            </form>

          </div>
        </>

      </Dialog>



      {/* Confirmation pop-up for Edit  */}
      <Dialog
        open={edituserDialog}
        onClose={hideEditUserDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
          {"Confirm Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {userList && (
              <span style={{ color: "black" }}>
                Are you sure, you want to edit user {" "}
                <b>{userList.email_address}</b>?
              </span>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel"
            variant="outlined"
            color="error"
            onClick={hideEditUserDialog}
          >
            No
          </Button>
          <Button className="btn-submit"
            variant="outlined"
            color="success"
            onClick={edituser}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>


      {/* Confirmation pop-up for send telegram link  */}
      <Dialog
        open={sendTelegramuserDialog}
        onClose={hideSendTelegramUserDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
          {"Confirm Send Telegram Link"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {userList && (
              <span style={{ color: "black" }}>
                Are you sure, you want to Send telegram link to user {" "}
                <b>{userList.mobile}</b>?
              </span>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel"
            variant="outlined"
            color="error"
            onClick={hideSendTelegramUserDialog}
          >
            No
          </Button>
          <Button className="btn-submit"
            variant="outlined"
            color="success"
            onClick={sendTelegramJoiningLink}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>


      {/* Confirmation pop-up for delete telegram user  */}
      <Dialog
        open={deleteTelegramuserDialog}
        onClose={hideDeleteTelegramUserDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
          {"Confirm Delete User From Telegram"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {userList && (
              <span style={{ color: "black" }}>
                Are you sure, you want to delete user from telegram channel{" "}
                <b>{userList.phone}</b>?
              </span>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel"
            variant="outlined"
            color="error"
            onClick={hideDeleteTelegramUserDialog}
          >
            No
          </Button>
          <Button className="btn-submit"
            variant="outlined"
            color="success"
            onClick={RemoveUserFromTelegram}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* delete user dialog */}
      <Dialog
        open={deleteUserDialog}
        onClose={hideDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ color: "#ff002d !important" }} id="alert-dialog-title">
          {"⚠️ Warning: Account Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {userList && (
              <>

                <p>
                  If you proceed, all information related to this account will be permanently deleted from database. This action cannot be undone, and this account cannot be recovered.

                </p>
                <span style={{ color: "black" }}>
                  Are you sure, you want to Delete{" "}
                  <b>{userList.email}</b>?
                </span>
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel"
            variant="outlined"
            color="error"
            onClick={hideDeleteDialog}
          >
            No
          </Button>
          <Button className="btn-submit"
            variant="outlined"
            color="success"
            onClick={deleteUser}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Blocked user dialog  */}
      <Dialog
        open={BlockUserDialog}
        onClose={hideBlockUSer}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
          {userList.is_blocked === false ? "Confirm Block" : "Confirm Unblock"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {userList && (
              <span style={{ color: "black" }}>
                Are you sure, you want to {userList.is_blocked === false ? "Block" : "Unblock"}{" "}
                <b>{userList.email}</b>?
              </span>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel"
            variant="outlined"
            color="error"
            onClick={hideBlockUSer}
          >
            No
          </Button>
          <Button className="btn-submit"
            variant="outlined"
            color="success"
            onClick={HandleBlockUser}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>


      {/* Confirmation pop-up for Login Limit  */}
      <Dialog
        open={LoginLimitDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
          {"Updating Login Limit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {userList && (
              LoginConfirm
                ?
                (<div>
                  <span>Login Limit: </span>
                  <input style={{ border: '2px solid gray', borderRadius: '5px' }} type="number" value={LoginLimitValue} onChange={(e) => { setLoginLimitValue(e.target.value) }} />
                </div>)
                :
                (<span style={{ color: "black" }}>
                  Are you sure, you want to Update user Login Limit {" "}
                  <b>{userList.email}</b>?
                </span>)
            )


            }
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          {!LoginConfirm &&
            <>

              <Button className="btn-cancel"
                variant="outlined"
                color="error"
                onClick={() => { setLoginLimitDialog(false) }}
              >
                No
              </Button>
              <Button className="btn-submit"
                variant="outlined"
                color="success"
                onClick={() => { setLoginConfirm(true) }}
                autoFocus
              >
                Yes
              </Button>
            </>
          }

          {LoginConfirm &&
            <>

              <Button className="btn-cancel"
                variant="outlined"
                color="error"
                onClick={() => { setLoginLimitDialog(false); setLoginConfirm(false); }}
              >
                Cancel
              </Button>
              <Button className="btn-submit"
                variant="outlined"
                color="success"
                onClick={handleUpdateLoginLimit}
                autoFocus
              >
                Update
              </Button>
            </>
          }
        </DialogActions>
      </Dialog>

      <Dialog open={errorpopup}>
        <div className="learnrkb-popup-one">
          <div className="CreateReport-Close">
            <i
              className="pi pi-times"
              onClick={() => {
                setErrorpopup(false);
              }}
              style={{ color: "#697565" }}
            ></i>
          </div>
          <div className="CreateReport_Page">
            <h1>Empty Field</h1>
            <p>Please fill all the required fields.</p>
          </div>
        </div>
      </Dialog>


      <Dialog open={validationError}>
        <div className="learnrkb-popup-one">
          <div className="CreateReport-Close">
            <i
              className="pi pi-times"
              onClick={() => {
                setValidationError(false);
              }}
              style={{ color: "#697565" }}
            ></i>
          </div>
          <div className="CreateReport_Page">
            {Errormessage}
          </div>
        </div>
      </Dialog>

      {/* success message  */}
      <Modal
        show={showSuccessMessage}
        onHide={() => setShowSuccessMessage(false)}
        style={{ padding: 0, zIndex: 9999 }}
      >
        {" "}
        <Alert variant="success">
          {Errormessage}
        </Alert>
      </Modal>


      {/* Failed pop up  */}
      <Modal
        show={showErrorMessage}
        onHide={() => setShowErrorMessage(false)}
        style={{ padding: 0 }}
      >
        {" "}
        <Alert variant="danger">{Errormessage}"</Alert>
      </Modal>

      <TelegramWidget />
      
      {sessionExpired ? <SessionLogout /> : null}
    </div>
  )
}

export default Userlist_Data
